/* eslint-disable @typescript-eslint/no-explicit-any */
import { defaultMemoize } from 'reselect';
import { noop } from 'es-toolkit';

import AppSettings from '../settings/AppSettings';
import fetch from 'cross-fetch';

/**
 * Memoize a function and add timezone as an arg
 * to protect against browser timezone changes. Should
 * be used in cases where the return value contains
 * a Javascript Date object
 * @param {function} func - The function to memoize
 */
export function memoizeWithTimezoneGuard<T>(func: (...args: any[]) => T) {
  const memoized = defaultMemoize((timezone: any, ...args: any[]) => {
    return func(...args);
  });
  return (...args: any[]) => {
    const now = new Date();
    const timeZone = now.getTimezoneOffset();
    return memoized(timeZone, ...args);
  };
}

export function guardTimezoneChange() {
  // Guard against timezone changes by refreshing the app.
  if (!(window as any).CURRENT_UTC_OFFSET) {
    const d = new Date();
    (window as any).CURRENT_UTC_OFFSET = d.getTimezoneOffset();
  }

  setInterval(() => {
    const date = new Date();
    if (!(window as any).CURRENT_UTC_OFFSET) {
      (window as any).CURRENT_UTC_OFFSET = date.getTimezoneOffset();
      return;
    }
    if ((window as any).CURRENT_UTC_OFFSET !== date.getTimezoneOffset()) {
      (window as any).CURRENT_UTC_OFFSET = date.getTimezoneOffset();
      (window as any).onbeforeunload = noop;
      location.reload();
    }
  }, 3000);
}

/**
 * Get a timezone in format America/Chicago for CST
 * giving a latitude and longitude
 */
export function getTimeZoneFromGoogleMapsApi(latitude: number, longitude: number) {
  const secondsSinceEpoch = Math.round(Date.now() / 1000);

  const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${secondsSinceEpoch}&key=${AppSettings.GOOGLE_TIME_ZONE_API_KEY}`;
  return fetch(url, {
    method: 'GET',
  });
}
